import { createFileRoute, redirect } from '@tanstack/react-router';

import { GoogleAnalyticsIntegrations } from '@mint-sdk/api-integrations';
import {
  AdserverUrnEnum,
  TRAFFICKING_PLATFORM_URN,
} from '@mint-sdk/api-integrations/compat';
import { Connection } from '@mint-sdk/api-omni';
import {
  Integrations,
  LocalStorage,
  Utils,
} from '@mint-sdk/api-omni-trafficking';
import { z } from 'zod';

export const Route = createFileRoute(
  '/_secured/external-data/integrations/$integration/connections/add',
)({
  validateSearch: z.object({
    state: z.string().optional(),
    code: z.string().optional(),
    oauth_token: z.string().optional(),
    oauth_verifier: z.string().optional(),
    oauth_result: z.string().optional(),
  }),
  async beforeLoad({ params, search }) {
    const { integration } = params;
    const { state, code } = search;

    // Handle OAuth callback for Campaign Manager update Flow
    // will be removed after refactoring and separating trafficking integrations
    const isCampaignManager =
      integration === TRAFFICKING_PLATFORM_URN.campaignManager;
    if (state && code && isCampaignManager) {
      const connectionId = LocalStorage.getConnectionIdFrom(
        TRAFFICKING_PLATFORM_URN.campaignManager,
      );
      const oauthFlowId = LocalStorage.getOauthFlowIdFrom(
        TRAFFICKING_PLATFORM_URN.campaignManager,
        state,
      );
      if (connectionId && oauthFlowId) {
        throw redirect({
          to: '/external-data/integrations/$integration/connections/$connection/update',
          params: { integration, connection: connectionId },
          search,
        });
      }
    }
  },
  loader: async ({ context, params }) => {
    await context.getInstance('i18n', '@myn/integrations_v2');
    const isReadOnly = !(await context.hasPermission('integrations:modify'));
    const { integration } = params;

    const queryClient =
      await context.serviceLocator.getOrThrowInstance('queryClient');

    let connectionList;
    if (Utils.getAdServerPlatformFrom(integration)) {
      connectionList = await queryClient.ensureQueryData(
        Integrations.getIntegrationList({
          params: {
            adServer: AdserverUrnEnum.safeParse(integration).data ?? null,
          },
        }),
      );
    } else if (
      // will be removed after refactoring and separating trafficking integrations
      integration === TRAFFICKING_PLATFORM_URN.googleAnalytics
    ) {
      connectionList = await queryClient.ensureQueryData(
        GoogleAnalyticsIntegrations.getGA4Integrations({}),
      );
    } else {
      connectionList = await queryClient.ensureQueryData(
        Connection.getConnectionList({
          params: {
            platform: integration,
          },
        }),
      );
    }

    if (isReadOnly && connectionList?.[0]) {
      throw redirect({
        to: '/external-data/integrations/$integration/connections/$connection/update',
        params: {
          integration,
          connection: connectionList[0].id,
        },
      });
    }
  },
});
